import PageReport from '../../components/page/Report.page'

const WorkspaceConstructionsPage = () => {
  return <PageReport owned />
}
export default WorkspaceConstructionsPage
